<ng-container *ngIf="!isEditLegendSettings; else timerLegendSettings">
    <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

    <div class="panel-options-body overflow-wrapper">
        <web-paid-access-notification-container [widgetName]="widget.name"></web-paid-access-notification-container>

        <form class="form form-horizontal" (submit)="$event.preventDefault()">
            <div class="form-row">
                <div class="form-group mb-0">
                    <label class="col-xs-12">
                        <label>
                            <input
                                type="radio"
                                [checked]="timerType.value === ETimerType.fixed"
                                (click)="setTimerType(ETimerType.fixed)"
                            />
                            {{ "control_fixed_timer_date" | translate }}
                        </label>
                        <label class="mb-0">
                            <input
                                type="radio"
                                [checked]="timerType.value === ETimerType.dynamic"
                                (click)="setTimerType(ETimerType.dynamic)"
                            />
                            {{ "control_dynamic_timer_date" | translate }}
                        </label>
                    </label>
                    <div *ngIf="timerType.value === ETimerType.fixed" class="col-xs-12 help-block small mt-0">
                        {{ "fixed_timer_date_hint" | translate }}
                    </div>
                    <div *ngIf="timerType.value === ETimerType.dynamic" class="col-xs-12 help-block small mt-0">
                        {{ "dynamic_timer_date_hint" | translate }}
                    </div>
                </div>

                <div *ngIf="timerType.value === ETimerType.fixed" class="form-group mb-20">
                    <div class="col-xs-12">
                        <web-date-time-picker
                            class="custom-popover"
                            [defaultDate]="untilDate.value"
                            (dateChange)="onDateChange($event)"
                        ></web-date-time-picker>
                    </div>
                </div>

                <div *ngIf="timerType.value === ETimerType.dynamic" class="form-group mb-20">
                    <div class="col-xs-3">
                        <sp-input-num
                            [min]="MIN_DAYS"
                            [max]="MAX_DAYS"
                            [value]="remainingTimeDays.value || MIN_DAYS"
                            (valueChange)="setRemainingTimeDays($event)"
                        ></sp-input-num>
                        <div class="text-muted small-xs text-center mt-5">
                            {{ "days" | translate }}
                        </div>
                    </div>
                    <div class="col-xs-3">
                        <sp-input-num
                            [min]="MIN_HOURS"
                            [max]="MAX_HOURS"
                            [value]="remainingTimeHours.value || MIN_HOURS"
                            (valueChange)="setRemainingTimeHours($event)"
                        ></sp-input-num>
                        <div class="text-muted small-xs text-center mt-5">
                            {{ "hours" | translate }}
                        </div>
                    </div>
                    <div class="col-xs-3">
                        <sp-input-num
                            [min]="MIN_MINUTES"
                            [max]="MAX_MINUTES"
                            [value]="remainingTimeMinutes.value || MIN_MINUTES"
                            (valueChange)="setRemainingTimeMinutes($event)"
                        ></sp-input-num>
                        <div class="text-muted small-xs text-center mt-5">
                            {{ "minutes" | translate }}
                        </div>
                    </div>
                    <div class="col-xs-3">
                        <sp-input-num
                            [min]="MIN_SECONDS"
                            [max]="MAX_SECONDS"
                            [value]="remainingTimeSeconds.value || MIN_SECONDS"
                            (valueChange)="setRemainingTimeMinutes($event)"
                        ></sp-input-num>
                        <div class="text-muted small-xs text-center mt-5">
                            {{ "seconds" | translate }}
                        </div>
                    </div>
                </div>

                <div *ngIf="timerType.value === ETimerType.dynamic" class="form-group mb-20">
                    <label class="control-label col-xs-9">
                        {{ "control_restart_timer" | translate }}
                    </label>
                    <div class="col-xs-3 control-switch text-right">
                        <sp-switch [control]="autorestart"></sp-switch>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_timer_expired_text" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <textarea class="form-control" [formControl]="expiredText"></textarea>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_timer_config" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <sp-datetime-slider [columns]="columns.value" (changeColumns)="setColumns($event)">
                        </sp-datetime-slider>
                        <a class="dotted" (click)="editTimerLegendSettings()">{{
                            "control_timer_config_setup_button" | translate
                        }}</a>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_appearance" | translate }}
                    </label>
                    <div class="col-xs-12 appearance-wrapper">
                        <sp-timer-appearance
                            [separator]="appearance.value"
                            (changeEvent)="setAppearance($event)"
                        ></sp-timer-appearance>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <web-color-picker
                            [color]="textColor.value"
                            (colorChangeEvent)="setTextColor($event)"
                        ></web-color-picker>
                    </div>
                </div>

                <!-- показываем если выбран "внешний вид" 2 и 3 варианты -->
                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_separator_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <web-color-picker
                            [color]="dividerColor.value"
                            (colorChangeEvent)="setDividerColor($event)"
                        ></web-color-picker>
                    </div>
                </div>

                <div class="form-group mb-10">
                    <div class="col-xs-12 device-toggle-wrapper">
                        <web-device-toggle></web-device-toggle>

                        <web-synchronize-style-toggle
                            [active]="isSynchronizeStyle.value"
                            (click)="setSynchronizeStyle()"
                        ></web-synchronize-style-toggle>
                    </div>
                </div>

                <ng-container *ngIf="isDeviceDesktop$ | async">
                    <div class="form-group mb-0">
                        <p class="col-xs-12 help-block text-muted small">
                            {{ "desktop_device_hint" | translate }}
                        </p>
                    </div>

                    <ng-container *ngTemplateOutlet="desktopSettings"> </ng-container>
                </ng-container>

                <ng-container *ngIf="isDeviceTablet$ | async">
                    <div class="form-group mb-0">
                        <p class="col-xs-12 help-block text-muted small">
                            {{ "tablet_device_hint" | translate }}
                        </p>
                    </div>

                    <ng-container *ngIf="isSynchronizeStyle.value; then desktopSettings; else tabletSettings">
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="isDeviceMobile$ | async">
                    <div class="form-group mb-0">
                        <p class="col-xs-12 help-block text-muted small">
                            {{ "mobile_device_hint" | translate }}
                        </p>
                    </div>

                    <ng-container *ngIf="isSynchronizeStyle.value; then desktopSettings; else mobileSettings">
                    </ng-container>
                </ng-container>

                <ng-template #desktopSettings>
                    <div class="form-group mb-20">
                        <label class="col-xs-7 control-label">
                            {{ "control_size" | translate }}
                        </label>

                        <div class="col-xs-5">
                            <sp-radio-group
                                [selected]="size.value"
                                [type]="ERadioGroupType.size"
                                (changeSelectedEvent)="setSize($event)"
                            ></sp-radio-group>
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-7 control-label">
                            {{ "control_content_alignment" | translate }}
                        </label>
                        <div class="col-xs-5">
                            <sp-radio-group
                                [selected]="horizontalAlign.value"
                                [type]="ERadioGroupType.horizontalPosition"
                                (changeSelectedEvent)="setHorizontalAlign($event)"
                            ></sp-radio-group>
                        </div>
                    </div>
                </ng-template>

                <ng-template #tabletSettings>
                    <div class="form-group mb-20">
                        <label class="col-xs-7 control-label">
                            {{ "control_size" | translate }}
                        </label>

                        <div class="col-xs-5">
                            <sp-radio-group
                                [selected]="tabletSize.value"
                                [type]="ERadioGroupType.size"
                                (changeSelectedEvent)="setTabletSize($event)"
                            ></sp-radio-group>
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-7 control-label">
                            {{ "control_content_alignment" | translate }}
                        </label>
                        <div class="col-xs-5">
                            <sp-radio-group
                                [selected]="tabletHorizontalAlign.value"
                                [type]="ERadioGroupType.horizontalPosition"
                                (changeSelectedEvent)="setTabletHorizontalAlign($event)"
                            ></sp-radio-group>
                        </div>
                    </div>
                </ng-template>

                <ng-template #mobileSettings>
                    <div class="form-group mb-20">
                        <label class="col-xs-7 control-label">
                            {{ "control_size" | translate }}
                        </label>

                        <div class="col-xs-5">
                            <sp-radio-group
                                [selected]="mobileSize.value"
                                [type]="ERadioGroupType.size"
                                (changeSelectedEvent)="setMobileSize($event)"
                            ></sp-radio-group>
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-7 control-label">
                            {{ "control_content_alignment" | translate }}
                        </label>
                        <div class="col-xs-5">
                            <sp-radio-group
                                [selected]="mobileHorizontalAlign.value"
                                [type]="ERadioGroupType.horizontalPosition"
                                (changeSelectedEvent)="setMobileHorizontalAlign($event)"
                            ></sp-radio-group>
                        </div>
                    </div>
                </ng-template>

                <div class="mt-20" style="margin-left: -10px; margin-right: -10px">
                    <web-widget-position-settings
                        [isSynchronized]="isSynchronizeStyle.value"
                        [isTablet]="isDeviceTablet$ | async"
                        [isMobile]="isDeviceMobile$ | async"
                        [widgetId]="widget.id"
                        [columnId]="widget.columnId"
                        [position]="position.value"
                        (positionChange)="position.patchValue($event)"
                    ></web-widget-position-settings>
                </div>

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>

                <web-widget-hide-settings
                    [hideOnDesktop]="hideOnDesktop.value"
                    [hideOnTablet]="hideOnTablet.value"
                    [hideOnMobile]="hideOnMobile.value"
                    (hideOnDesktopChange)="hideOnDesktop.setValue($event)"
                    (hideOnTabletChange)="hideOnTablet.setValue($event)"
                    (hideOnMobileChange)="hideOnMobile.setValue($event)"
                ></web-widget-hide-settings>

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>

                <div class="form-group mt-20">
                    <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                    </web-custom-id>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-template #timerLegendSettings>
    <web-timer-legend-setting
        [item]="customLabels.value"
        (saveEvent)="saveLegendSettings($event)"
        (cancelEvent)="closeLegendSettings()"
    ></web-timer-legend-setting>
</ng-template>
